export default __webpack_public_path__ + "static/media/img-newsupdate-header.02ff9b8d.jpg";